<template>
    <div class="d-inline-block">
        <span class="chip chip-custom"
              :class="{[chipClasses.join(' ')]: true}"
              @click="onClickChip"
              :style="{ backgroundColor: chipColor, borderColor}">{{ chipText }}</span>
    </div>
</template>

<script>
import {generateColor, getChipText} from '@/utils/misc';

export default {
    name: 'ChipGeneral',
    props: {
        borderColor: {
            type: String,
            default: 'transparent'
        },
        userName: String,
        userRole: String,
        chipClasses: {
            type: Array,
            default() {
                return ['chip-size-24'];
            }
        }
    },
    computed: {
        chipText: vm => getChipText(vm.userName),
        chipColor: vm => generateColor(vm.userName)
    },
    methods: {
        onClickChip() {
            this.$emit('click-chip');
        }
    }
}
</script>
